var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "flex-direction": "column" } },
    [
      _c(
        "div",
        [
          _c(
            "el-button",
            {
              attrs: { disabled: _vm.disabled, type: "primary" },
              on: { click: _vm.getPackingInformation }
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("SeaExport.GetPackingInformation")) + " "
              )
            ]
          )
        ],
        1
      ),
      _c(
        "cargo-input",
        _vm._g(
          _vm._b(
            {
              staticStyle: { width: "100%" },
              attrs: {
                disabled: _vm.disabled,
                "auto-uppercase": true,
                type: "textarea",
                rows: 5,
                "filter-chars": false
              },
              model: {
                value: _vm.cargoDoc.container,
                callback: function($$v) {
                  _vm.$set(_vm.cargoDoc, "container", $$v)
                },
                expression: "cargoDoc.container"
              }
            },
            "cargo-input",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }